<!-- Google tag (gtag.js) -->
// window.dataLayer = window.dataLayer || [];
// function gtag() {
//   dataLayer.push(arguments);
// }

// Default ad_storage to 'denied'.
// gtag('consent', 'default', {
//     'ad_storage': 'denied',
//     'analytics_storage': 'denied',
//     'ad_personalization': 'denied',
//     'ad_user_data': 'denied',
//     'wait_for_update': 500,
//     'region': ["AT", "BE", "BG", "CY", "CZ", "DE", "DK", "EE", "ES", "FI", "FR", "GR", "HR", "HU", "IE", "IS", "IT", "LI", "LT", "LU", "LV", "MT", "NL", "NO", "PL", "PT", "RO", "SE", "SI", "SK","GB","CH"]
// });

// gtag("js", new Date());


<!-- End Google tag (gtag.js) -->


window.addEventListener("load", function (event) {
  setTimeout(function () {
    gtag("event", "pageview_60s");
  }, 60000);

  setTimeout(function () {
    gtag("event", "pageview_90s");
  }, 90000);


  // 选择第二个具有 class="airiosoft_footer_nav_menu" 的元素
  const secondMenu = document.querySelector('.airiosoft_footer_nav_menu:nth-of-type(2)');
// 选择该元素下的 class="airiosoft_footer_nav_menu_links" 的子元素
  const linksContainer = secondMenu.querySelector('.airiosoft_footer_nav_menu_links');
// 获取该容器内的所有 <a> 标签
  const links = linksContainer.querySelectorAll('a');
// 检查是否有至少两个链接
  if (links.length >= 2) {
    // 设置第一个和第二个链接的 target 属性为 "_blank"
    links[0].setAttribute('target', '_blank');
    links[1].setAttribute('target', '_blank');
  }

});


function ChangeTheNumberOfCarts() {
  // fetch(window.Shopify.routes.root + 'cart.js', {
  //   method: 'GET',
  //   headers: {
  //     'Content-Type': 'application/json'
  //   }
  // }).then((response) => response.json()).then((response) => {
  //   // console.log('response json: ',response);
  //   console.log('response.item_count: ',response.item_count);
  //   let cart_count_content_wap=document.getElementById('cart_count_content_wap');
  //   let cart_count_content=document.getElementById('cart_count_content');
  //   if(cart_count_content){
  //     if (response.item_count){
  //       cart_count_content_wap.style.display='flex';
  //       cart_count_content.innerHTML=response.item_count;
  //     }else {
  //       cart_count_content_wap.style.display='none';
  //     }
  //   }
  // })
}
